import React, { useState, useEffect } from "react";
import "./cartpage.css";
import Nav from "../../components/nav/nav";
import Footer from "../../components/footer/Footer";
import PaymentIcon from "react-payment-icons";
import { FaCcVisa, FaCcMastercard } from "react-icons/fa";
import { SiRupay } from "react-icons/si";
import { FaGooglePay } from "react-icons/fa6";
import { MdAccountBalanceWallet } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import LoginPopup from "../../components/Login/loginPopup";

const CartPage = () => {
    const navigate = useNavigate();
    const [showLogin, setShowLogin] = useState(false);

    const isLoggedIn = !!localStorage.getItem("idToken");

    // ✅ ONLY CHANGE: empty state
    const [cartItems, setCartItems] = useState([]);

    const [selectAll, setSelectAll] = useState(true);
    const handleNavigate = (id) => {
        navigate(`/product-details/${id}`);
    };
    console.log("cartitems :",cartItems);
    // ✅ ONLY CHANGE: API CALL
    useEffect(() => {
        const fetchCart = async () => {
            try {
                const token = localStorage.getItem("idToken");

                const res = await fetch("https://host.aizoplug.com:3000/ecommerce/cart", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const data = await res.json();

                if (data.success) {
                    console.log("Cart data:", data.data);
                    console.log("")
                    const formatted = data.data.map(item => ({
                        id: item.product_id,
                        name: item.title,
                        price: item.mrp,
                        quantity: item.quantity,
                        image: item.images?.length
                            ? "https://api.aizoteq.com:3000" + item.images[0]
                            : "/default.png",
                        inStock: true,
                        selected: true
                    }));

                    setCartItems(formatted);
                }

            } catch (err) {
                console.log(err);
            }
        };

        if (isLoggedIn) {
            fetchCart();
        }
    }, []);

    const handleCheckout = () => {
        if (selectedCount > 0) {
            navigate('/checkout', {
                state: {
                    selectedItems: selectedItems,
                    totalAmount: selectedTotal,
                    cartItems: cartItems
                }
            });
        }
    };
    // UPDATE QUANTITY (BACKEND CONNECTED)

    // REMOVE ITEM (BACKEND CONNECTED)

    // const updateQuantity = (id, qty) => {
    //     setCartItems(items =>
    //         items.map(item =>
    //             item.id === id ? { ...item, quantity: Math.max(1, qty) } : item
    //         )
    //     );
    // };
    const updateQuantity = async (id, qty) => {
        try {
            const token = localStorage.getItem("idToken");

            await fetch("https://host.aizoplug.com:3000/ecommerce/cart/update", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    product_id: id,
                    quantity: Math.max(1, qty)
                })
            });

            setCartItems(items =>
                items.map(item =>
                    item.id === id
                        ? { ...item, quantity: Math.max(1, qty) }
                        : item
                )
            );
            window.dispatchEvent(new Event("cartUpdated"));
        } catch (err) {
            console.log(err);
        }
    };


    // const removeItem = id => {
    //     setCartItems(items => items.filter(item => item.id !== id));
    //     if (cartItems.filter(item => item.id !== id).every(item => item.selected)) {
    //         setSelectAll(true);
    //     }
    // };
    const removeItem = async (id) => {
        try {
            const token = localStorage.getItem("idToken");

            await fetch(`https://host.aizoplug.com:3000/ecommerce/cart/remove/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setCartItems(items => items.filter(item => item.id !== id));

            if (cartItems.filter(item => item.id !== id).every(item => item.selected)) {
                setSelectAll(true);
            }
            window.dispatchEvent(new Event("cartUpdated"));
        } catch (err) {
            console.log(err);
        }
    };

    const toggleItemSelection = (id) => {
        setCartItems(items =>
            items.map(item =>
                item.id === id ? { ...item, selected: !item.selected } : item
            )
        );

        setTimeout(() => {
            setCartItems(currentItems => {
                const allSelected = currentItems.every(item => item.selected);
                setSelectAll(allSelected);
                return currentItems;
            });
        }, 0);
    };

    const toggleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);
        setCartItems(items =>
            items.map(item => ({ ...item, selected: newSelectAll }))
        );
    };

    const removeSelected = () => {
        setCartItems(items => items.filter(item => !item.selected));
        setSelectAll(false);
    };

    const selectedItems = cartItems.filter(item => item.selected);
    const selectedTotal = selectedItems.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
    );
    const selectedCount = selectedItems.length;

    return (
        <div className="cart-page-wrapper">
            <Nav />
            <div className="cart-page">
                <div className="cart-header">
                    <h1 className="cart-title">Shopping Cart</h1>
                    <p className="cart-subtitle">
                        {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'} in your cart
                    </p>
                </div>

                {!isLoggedIn ? (
                    <div className="login-required">
                        <h2>Please Login to Continue</h2>
                        <p>You need to login to view your cart</p>

                        <button
                            className="login-btn"
                            onClick={() => setShowLogin(true)}
                        >
                            Login
                        </button>
                    </div>
                ) : cartItems.length === 0 ? (
                    <div className="cart-empty-state">
                        <div className="empty-cart-icon">🛒</div>
                        <h2>Your cart is empty</h2>
                        <p>Looks like you haven't added anything to your cart yet</p>
                        <button className="continue-shopping-btn" onClick={() => window.location.href = '/product'}>
                            Continue Shopping
                        </button>
                    </div>
                ) : (
                    <div className="cart-layout">
                        <div className="cart-items-section">
                            <div className="cart-toolbar">
                                <div className="select-all-wrapper">
                                    <label className="custom-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={toggleSelectAll}
                                        />
                                        <span className="checkmark"></span>
                                        <span className="select-all-text">
                                            Select All ({cartItems.length} items)
                                        </span>
                                    </label>
                                </div>
                            </div>

                            <div className="cart-items">
                                {cartItems.map(item => (
                                    <div className={`cart-item ${!item.inStock ? 'out-of-stock' : ''}`} key={item.id} onClick={() => handleNavigate(item.id)}>
                                        <div className="item-select">
                                            <label className="custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    checked={item.selected}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={() => toggleItemSelection(item.id)}
                                                    disabled={!item.inStock}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>

                                        <div className="item-image">
                                            <img src={item.image} alt={item.name} />
                                            {!item.inStock && <span className="stock-badge">Out of Stock</span>}
                                        </div>

                                        <div className="cart-item-info">
                                            <h3>{item.name}</h3>
                                            <div className="item-price-mobile">
                                                ₹{item.price.toLocaleString()}
                                            </div>

                                            {item.inStock ? (
                                                <div className="cart-qty">
                                                    <button
                                                        className="qty-btn"

                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            updateQuantity(item.id, item.quantity - 1);
                                                        }}

                                                        disabled={!item.selected}
                                                    >−</button>

                                                    <span className="qty-value">{item.quantity}</span>

                                                    <button
                                                        className="qty-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            updateQuantity(item.id, item.quantity + 1);
                                                        }}
                                                        disabled={!item.selected}
                                                    >+</button>
                                                </div>
                                            ) : (
                                                <button className="notify-btn">Notify Me</button>
                                            )}
                                        </div>

                                        <div className="cart-item-price">
                                            <div className="price-label">Price</div>
                                            <span className="item-price">
                                                ₹{item.price.toLocaleString()}
                                            </span>
                                        </div>

                                        <div className="cart-item-total">
                                            <div className="total-label">Total</div>
                                            <span className="item-total">
                                                ₹{(item.price * item.quantity).toLocaleString()}
                                            </span>
                                        </div>

                                        <div className="cart-item-actions">
                                            <button
                                                className="action-btn remove-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    removeItem(item.id);
                                                }}
                                            >
                                                <span className="action-icon">
                                                    <FaTrashAlt />
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="cart-summary">
                            <h2>Order Summary</h2>

                            <div className="summary-details">
                                <div className="summary-row">
                                    <span>Selected Items</span>
                                    <span className="summary-value">{selectedCount}</span>
                                </div>

                                <div className="summary-row">
                                    <span>Items Total</span>
                                    <span className="summary-value">
                                        ₹{selectedTotal.toLocaleString()}
                                    </span>
                                </div>

                                <div className="summary-row">
                                    <span>Shipping</span>
                                    <span className="summary-value free-shipping">FREE</span>
                                </div>

                                <div className="summary-divider"></div>

                                <div className="summary-row total">
                                    <span>Total Amount</span>
                                    <span className="total-value">
                                        ₹{selectedTotal.toLocaleString()}
                                    </span>
                                </div>
                            </div>

                            <button
                                className="checkout-btn"
                                disabled={selectedCount === 0}
                                style={{ opacity: selectedCount === 0 ? 0.6 : 1 }}
                                onClick={handleCheckout}
                            >
                                Proceed to Checkout ({selectedCount} {selectedCount === 1 ? 'item' : 'items'})
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <Footer />

            <LoginPopup
                show={showLogin}
                onClose={() => setShowLogin(false)}
            />
        </div>
    );
};

export default CartPage;